import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';

import { connect } from 'react-redux';

import Seacrch from './search';
import Actions from './actions';

import { actions as installersListActions } from 'redux/distributors/distributorList/reducer';
import { getInstallersTableData } from 'redux/distributors/distributorList/selector';

import DataTable from 'components/dataTable';

import ctn from 'helpers/countries';

import Button from '@material-ui/core/Button';
import { getStatusFile } from 'redux/reports/selector';
import { requests as reportsRequests } from 'redux/reports/reducer';
import { getCountryProfile } from 'redux/profile/selector';

// TODO revisar si van los RUNS
const columns = [
  { prop: 'country', label: 'Pais', format: ctn },
  { prop: 'shopName', label: 'Empresa' },
  { prop: 'name', label: 'Razon social' },
  { prop: 'users[0].firstname', label: 'Nombre' },
  { prop: 'users[0].lastname', label: 'Apellido' },
  { prop: 'state', label: 'Provincia' },
  // {
  //   prop: '',
  //   label: 'Perfil',
  //   format: (value, row) => {
  //     const building = row.building ? 'Auto' : ' ';
  //     const auto = row.auto ? 'Arquitectura' : ' ';
  //     return (
  //       <>
  //         <FormattedMessage id={building} /> <FormattedMessage id={auto} />
  //       </>
  //     );
  //   },
  // },
  // {
  //   prop: 'autoWarranties',
  //   label: 'Cert. de garantias autos',
  // },
  // {
  //   prop: 'buildingWarranties',
  //   label: 'Cert. de garantias arquitectura',
  // },
  {
    prop: 'uuid',
    label: 'Acciones',
    format: (value, row) => <Actions {...{ value }} />,
  },
];

const Table = ({ setFilter, downloadFile, country, file, ...props }) => {
  useEffect(() => {
    setFilter();
  }, [setFilter]);

  if (
    country == 'AR' ||
    country == 'BO' ||
    country == 'CE' ||
    country == 'CL' ||
    country == 'CO' ||
    country == 'CR' ||
    country == 'DO' ||
    country == 'EC' ||
    country == 'GT' ||
    country == 'HN' ||
    country == 'JM' ||
    country == 'MX' ||
    country == 'PA' ||
    country == 'PE' ||
    country == 'PY' ||
    country == 'SV' ||
    country == 'UY'
  ) {
    fileName = 'distribuidores.csv';
  } else if (country == 'BR' || country == 'PT') {
    fileName = 'distribuidores.csv';
  } else if (country == 'DE') {
    fileName = 'Händler.csv';
  } else if (country == 'NL') {
    fileName = 'Distributeurs.csv';
  } else {
    fileName = 'distributor.csv';
  }

  return (
    <>
      <div className="row">
        <div className="col-xs-6 col-md-6 col-lg-3">
          <Seacrch />
        </div>
        <div className="col-xs-6 col-md-6 col-lg-1 offset-lg-8">
          <Button
            variant="outlined"
            onClick={downloadFile}
            disabled={file.isLoading}
          >
            <FormattedMessage id="Export..." />
          </Button>
        </div>
      </div>
      <div>
        <div className="kt-space-20" />
        <DataTable
          columns={columns}
          onChangePage={(e, v) =>
            setFilter({
              page: v + 1,
            })
          }
          onChangeRowsPerPage={(e) =>
            setFilter({
              page: 1,
              perPage: e.target.value,
            })
          }
          {...props}
        />
      </div>
    </>
  );
};

let fileName;

export const mapStateToProps = (state) => ({
  ...getInstallersTableData(state),
  file: getStatusFile(fileName)(state),
  country: getCountryProfile(state),
});
export const mapDispatchToProps = (dispatch) => ({
  setFilter: (filter) => dispatch(installersListActions.setFilter(filter)),
  downloadFile: () =>
    dispatch(
      reportsRequests.fetch({
        report: '/reports/distributors',
        fileName,
      }),
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(Table);

// export const mapDispatchToProps = (dispatch) => ({
//   setFilter: (filter) => dispatch(installersListActions.setFilter(filter)),
// });

// export default connect(getInstallersTableData, mapDispatchToProps)(Table);
